export const UPDATE_NETWORK_STATUS = 'UPDATE_NETWORK_STATUS';
export const NETWORK_STATUS_ONLINE = 'NETWORK_STATUS_ONLINE';

export function updateNetworkStatus(status) {
    return {
        type: UPDATE_NETWORK_STATUS,
        payload: status,
    };
}
